import React, { useState } from 'react';
import { LogIn } from 'lucide-react';
import { api } from '../utils/api';
import { PushNotifications } from '@capacitor/push-notifications';
import { Capacitor } from '@capacitor/core';
import { getApiBase } from '../utils/api';

const Login = ({ setUser, setCurrentPage }) => {
  // 1. REMOVE employee_id from state
  // OLD: const [formData, setFormData] = useState({ employee_id: '', national_id: '' });
  const [formData, setFormData] = useState({ national_id: '' }); // NEW STATE

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // Ensure national_id is present before calling API
    if (!formData.national_id) {
        setError('กรุณาใส่เลขบัตรประชาชน');
        setLoading(false);
        return;
    }

    try {
      const data = await api.login(formData);

      if (data.success) {
        localStorage.setItem('auth_token', data.token);
        localStorage.setItem('user_data', JSON.stringify(data.user));
        setUser(data.user);

        // ==========================================
        // [✅ เพิ่มใหม่] ส่ง FCM Token ทันทีหลังล็อกอินสำเร็จ
        // ==========================================
        if (Capacitor.isNativePlatform()) {
          try {
            // 1. ขอสิทธิ์แจ้งเตือน
            const permStatus = await PushNotifications.requestPermissions();
            if (permStatus.receive === 'granted') {
              // 2. ลงทะเบียนเพื่อรับ Token
              await PushNotifications.register();
              
              // 3. ดักรับ Token แล้วส่งไปบันทึกที่ Database
              PushNotifications.addListener('registration', async (token) => {
                await fetch(`${getApiBase()}update-fcm-token`, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ 
                    employee_id: data.user.employee_id, 
                    fcm_token: token.value 
                  })
                });
                console.log('✅ FCM Token updated after login');
              });
            }
          } catch (pushError) {
            console.error('Push Notification Error:', pushError);
          }
        }
        // ==========================================

        if (data.user.is_super_admin) {
          setCurrentPage('super-admin-dashboard');
        } else if (data.user.is_admin || data.user.is_staff) {
          setCurrentPage('admin-dashboard');
        } else {
          setCurrentPage('face-scanner');
        }
      } else {
        setError(data.error || 'เข้าสู่ระบบไม่สำเร็จ');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto">
      <div className="bg-white p-8 rounded-lg shadow-lg">
        <div className="text-center mb-8">
          <LogIn className="h-12 w-12 text-blue-500 mx-auto mb-4" />
          <h1 className="text-2xl font-bold text-gray-900">เข้าสู่ระบบ</h1>
          <p className="text-gray-600 mt-2">เพื่อดูรายงานและจัดการข้อมูล</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* 2. REMOVE the 'รหัสบุคลากร' input field entirely */}
          {/* <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">รหัสบุคลากร</label>
            <input
              type="text"
              value={formData.employee_id}
              onChange={(e) => setFormData({...formData, employee_id: e.target.value})}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="เช่น EMP001"
              required
            />
          </div> 
          */}

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">เลขบัตรประชาชน</label>
            <input
              type="text"
              value={formData.national_id}
              onChange={(e) => setFormData({...formData, national_id: e.target.value})}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="13 หลัก"
              maxLength="13"
              required
            />
          </div>

          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-md">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-500 text-white py-3 px-4 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 transition-colors"
          >
            {loading ? 'กำลังเข้าสู่ระบบ...' : 'เข้าสู่ระบบ'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;